export const PLATFORM = {
  ISR_CONTAINER: 'ISR_CONTAINER',
  PUBLISHER: 'PUBLISHER',
  INSTANT_PREVIEW: 'INSTANT_PREVIEW',
  SITE_CREATOR: 'SITE_CREATOR',
  EASY_EDITOR: 'EASY_EDITOR',
  CONTENTFUL: 'CONTENTFUL',
}

export const PROCESS = {
  REVALIDATE_PATH: 'REVALIDATE_PATH',
  SYNC_APP: 'SYNC_APP',
  STAGE_PUBLISH: 'STAGE_PUBLISH',
  PUBLISH: 'PUBLISH',
  STAGE: 'STAGE',
  SYNC_APP_FAILED: 'SYNC_APP_FAILED',
  SYNC_APP_SUCCESS: 'SYNC_APP_SUCCESS',

  /// Orchestrator V2
  CREATE_STAGE: 'CREATE_STAGE',
  CREATE_WIP: 'CREATE_WIP',
  DISCARD_ENV: 'DISCARD_ENV',
  STAGING: 'STAGING',
  PUBLISHING: 'PUBLISHING',
  RESTORE_BACKUP: 'RESTORE_BACKUP',
  MIGRATE_BRANCH: 'MIGRATE_BRANCH',
}

export const ENVIRONMENT = {
  STAGE: 'STAGE',
  WIP: 'WIP',
  PRODUCTION: 'PRODUCTION',
}

export const LOCK_STATUS = {
  LOCKED: 'LOCKED',
  UNLOCKED: 'UNLOCKED',
}
